// StaffVisit.jsx
// スタッフ訪問の依頼（2026-09-11・#392・坂田社長承認）。マンション版 otype=13 と同じ流れ。
//   ご依頼 → 店へメール・お客様へ受付通知 → 担当店から訪問日時のご連絡
// フェーズ2: app_settings.staff_visit_calendar='1' のときは希望日（第3希望まで）を選んでもらう。
import { IoChevronBack } from "react-icons/io5";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics, Gtag } from '../compornents/Analytics';
import { VisitCalendar } from '../compornents/VisitCalendar';

const WD = ['日', '月', '火', '水', '木', '金', '土'];
const fmt = (ymd) => {
  if (!ymd) return '';
  const d = new Date(`${ymd}T12:00:00+09:00`);
  return `${ymd.slice(5, 7)}/${ymd.slice(8, 10)}（${WD[d.getUTCDay()]}）`;
};

export const StaffVisit = () => {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const orderId = sp.get('order');            // 既存依頼の状況表示（注文履歴から）
  const [info, setInfo] = useState(null);
  const [order, setOrder] = useState(null);
  const [memo, setMemo] = useState('');
  const [picks, setPicks] = useState([]);
  const [showImg, setShowImg] = useState(false);
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {});

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 10);
    (async () => {
      const r = await Post('post', '/order/staff_visit_info.php', {});
      if (r && r.result === 1) setInfo(r);
      if (orderId) {
        const d = await Post('post', '/order/detail.php', { order_id: orderId });
        if (d && d.result === 1 && d.order) setOrder(d.order);
      }
    })();
  }, [orderId]);

  const back = () => navigate(orderId ? '/orders' : '/home');
  const calOn = info && info.calendar && Number(info.calendar.enabled) === 1;

  const submit = async () => {
    if (calOn && picks.length === 0) { toast.error('ご希望日を1つ以上お選びください'); return; }
    openLoadingModal();
    const res = await Post('post', '/order/staff_visit.php', { memo, visit_prefs: JSON.stringify(calOn ? picks : []) });
    closeLoadingModal();
    if (res && res.result === 1) {
      Gtag('staff_visit_submit', { prefs: (res.visit_prefs || []).length });
      toast.success('スタッフ訪問のご依頼を受け付けました。訪問日時は担当店よりご連絡いたします。');
      navigate('/orders');
    } else {
      toast.error((res && res.error_message) || '送信に失敗しました');
    }
  };

  // 既存依頼の状況
  if (orderId) {
    const prefs = order ? [order.visit_pref1, order.visit_pref2, order.visit_pref3].filter(Boolean) : [];
    return (
      <div className="App">
        <div className="Inquiry">
          <Analytics title="スタッフ訪問の状況" />
          <div className="mt-3 mb-5 text-left">
            <div className="h3 mt-4 mb-4"><span className="div_btn mr-2" onClick={back}><IoChevronBack /></span>スタッフ訪問の状況</div>
            {!order ? <TailSpin stroke="#000" /> : (
              <div style={{ border: '1px solid #ddd', borderRadius: 12, padding: 16, background: '#fff' }}>
                <div style={{ fontSize: 13, color: '#666' }}>ご依頼 #{order.id}</div>
                {order.visit_confirmed ? (
                  <>
                    <div style={{ fontSize: 13, color: '#666', marginTop: 10 }}>訪問日</div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: '#15803d' }}>{fmt(order.visit_confirmed)} {order.visit_time_note || ''}</div>
                  </>
                ) : (
                  <>
                    <div style={{ fontSize: 15, fontWeight: 700, marginTop: 10 }}>訪問日を調整中です</div>
                    <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>担当店より日時のご連絡をいたします。しばらくお待ちください。</div>
                    {prefs.length > 0 && <div style={{ fontSize: 13, marginTop: 10 }}>ご希望日: {prefs.map((p, i) => `第${i + 1} ${fmt(p)}`).join('　')}</div>}
                  </>
                )}
                {order.internal_notes && <div style={{ fontSize: 13, color: '#444', marginTop: 12, whiteSpace: 'pre-wrap' }}>メモ: {order.internal_notes}</div>}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="Inquiry">
        <Analytics title="スタッフ訪問の依頼" />
        <div className="mt-3 mb-5 text-left">
          <div className="h3 mt-4 mb-4"><span className="div_btn mr-2" onClick={back}><IoChevronBack /></span>スタッフ訪問の依頼</div>
          {!info ? <TailSpin stroke="#000" /> : Number(info.enabled) !== 1 ? (
            <div>この拠点ではスタッフ訪問を受け付けておりません。</div>
          ) : (
            <>
              <p style={{ fontSize: 14, lineHeight: 1.7 }}>
                専用バッグに入らないふとん・カーテン・毛布、衣替えのまとめ出しなどは、スタッフがご自宅へ伺ってお預かりします。
                ロッカーへのお預け入れは不要です。
              </p>
              {info.menu_img && (
                <div style={{ marginBottom: 14 }}>
                  <img src={info.menu_img} alt="スタッフ訪問の料金表" onClick={() => setShowImg(true)}
                    style={{ width: '100%', borderRadius: 8, border: '1px solid #ddd', cursor: 'zoom-in' }} />
                  <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>※訪問時のご利用料金はパック料金ではなく、上記料金表がもとになります。タップで拡大できます。</div>
                </div>
              )}
              {calOn && (
                <div style={{ border: '1px solid #ddd', borderRadius: 12, padding: 14, background: '#fff', marginBottom: 14 }}>
                  <div style={{ fontWeight: 700, marginBottom: 6 }}>ご希望の訪問日（第3希望まで）</div>
                  <VisitCalendar days={info.calendar.days} picks={picks} onChange={setPicks} />
                </div>
              )}
              <div className="mb-3">
                <div style={{ fontWeight: 700, marginBottom: 4 }}>ご依頼の内容（任意）</div>
                <textarea className="form-control" rows={4} maxLength={500} value={memo} onChange={(e) => setMemo(e.target.value)}
                  placeholder="例）ふとん2枚とカーテン。平日は18時以降が助かります" />
              </div>
              <button className="button-next" onClick={submit} disabled={calOn && picks.length === 0}>
                {calOn && picks.length === 0 ? 'ご希望日を選んでください' : 'スタッフ訪問を依頼する'}
              </button>
              <div style={{ fontSize: 12, color: '#666', marginTop: 10 }}>
                ご依頼後、担当店（{info.gcompany_name}）より訪問日時のご連絡をいたします。
              </div>
            </>
          )}
        </div>
        {showImg && info?.menu_img && (
          <div onClick={() => setShowImg(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.85)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}>
            <img src={info.menu_img} alt="" style={{ maxWidth: '100%', maxHeight: '100%' }} />
          </div>
        )}
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div><TailSpin stroke="#000" /></div>
            <div>送信中です</div>
          </div>
        </LoadingModal>
      </div>
    </div>
  );
};
